
import { GiftshopProduct } from '@/models/Giftshop';
import { ProductResourceImage } from '@/models/Product';

import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
    name: 'GiftshopSelectionProduct',
    components: {
    }
})
export default class GiftshopSelectionProduct extends Vue {
    @Prop({ type: Object, required: true }) product: GiftshopProduct;
    @Prop({ type: String, required: false, default: "view" }) imageClickEvent: string;

    get translationsReady(): boolean {
        return this.$root.$data.translationsLoaded === true;
    }

    get secondaryImage(): ProductResourceImage {
        return this.product?.images?.[1];
    }
}
